var _circle, _circle2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.2,
    cy: 55.2,
    r: 2.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.8,
    cy: 55.2,
    r: 2.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9 63.3h-3.6v-1.2c0-1.7-1.4-3.2-3.2-3.2-.8 0-1.4.3-2 .7-.5-.4-1.2-.7-2-.7s-1.4.3-2 .7c-.5-.4-1.2-.7-2-.7s-1.4.3-2 .7c-.5-.4-1.2-.7-2-.7-1.7 0-3.2 1.4-3.2 3.2v1.2h-7c.1-.3.1-.5.2-.8 2.7-.6 4-2.5 4-5.8 0-2.5-.6-4.3-1.8-5.4-.5-.5-1.3-.9-2.5-1.1.1-1.8 0-4-.2-6.6-.1-1.4-.3-2.5-.6-3.6.4-2 .6-4.2.3-6-.1-.6-.8-1-1.5-.8-.4.1-.7.3-1.1.4.1-.6.1-1.1 0-1.7-.1-.7-.8-1.1-1.5-.9-2.9 1.1-7.1 2.1-12.5 2.1-8.9 0-16.2.4-16.9 10.5-.2 2.7-.2 4.8-.2 6.6-1.2.1-2 .6-2.5 1.1-1.2 1.1-1.8 2.9-1.8 5.4 0 3.3 1.3 5.2 4 5.8 0 .3.1.5.2.8h-6.9v-1.2c0-1.7-1.4-3.2-3.2-3.2-.8 0-1.4.3-2 .7-.5-.4-1.2-.7-2-.7s-1.4.3-2 .7c-.5-.4-1.2-.7-2-.7s-1.4.3-2 .7c-.5-.4-1.2-.7-2-.7-1.7 0-3.2 1.4-3.2 3.2v1.2H4.1c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6h4.6c.6.5 1.3.8 2.1.8.5 0 1-.1 1.5-.4.6.7 1.5 1.2 2.5 1.2.5 0 1-.1 1.5-.4.6.8 1.5 1.3 2.5 1.3s1.9-.5 2.5-1.3c.4.2.9.4 1.5.4 1.2 0 2.2-.7 2.7-1.6h49.1c.5 1 1.6 1.6 2.8 1.6.5 0 1-.1 1.5-.4.6.8 1.5 1.3 2.5 1.3s1.9-.5 2.5-1.3c.4.2.9.4 1.5.4 1 0 1.9-.5 2.5-1.2.4.2.9.4 1.5.4.8 0 1.5-.3 2.1-.8h4.6c.9 0 1.6-.7 1.6-1.6-.2-.9-.9-1.6-1.8-1.6zm-6.7-2c.4 0 .8.4.8.8v2c0 .4-.4.8-.8.8s-.8-.4-.8-.8v-2c0-.4.4-.8.8-.8zm-53.6 0c-.1-1-.9-1.7-1.8-1.8-1.2-.1-2-.2-2-2.8 0-2.1.5-2.8.8-3 .1-.1.3-.3.9-.3.1 1 .2 1.9.3 2.4.3 1.1 3 1 3.2.1.2-.8-.5-6.1 2-10.8 2.6 1.1 6.5 1.8 11 1.8s8.4-.7 11-1.8c2.5 4.7 1.9 10 2 10.8.2.9 2.9 1 3.2-.1.1-.5.2-1.4.3-2.4.6 0 .8.2.9.3.3.3.8 1 .8 3 0 2.6-.8 2.7-2 2.8-1 .1-1.7.8-1.8 1.8-.1.7-.2 1.3-.4 2H36c-.1-.6-.3-1.3-.4-2zm-25.6.8c0-.4.4-.8.8-.8s.8.4.8.8v2c0 .4-.4.8-.8.8s-.8-.3-.8-.8v-2zm4.8 3.7c-.4 0-.8-.4-.8-.8v-2.8c0-.4.4-.8.8-.8s.8.4.8.8V65c0 .4-.4.8-.8.8zm4.7 0c0 .4-.4.8-.8.8s-.8-.4-.8-.8V62.2c0-.4.4-.8.8-.8s.8.4.8.8V65.8zm4-.8c0 .4-.4.8-.8.8s-.8-.4-.8-.8v-2.8c0-.4.4-.8.8-.8s.8.4.8.8V65zm53.8.8c-.4 0-.8-.4-.8-.8v-2.8c0-.4.4-.8.8-.8s.8.4.8.8V65c0 .4-.3.8-.8.8zm4.8 0c0 .4-.4.8-.8.8s-.8-.4-.8-.8V62.2c0-.4.4-.8.8-.8s.8.4.8.8V65.8zM86 65c0 .4-.4.8-.8.8s-.8-.4-.8-.8v-2.8c0-.4.4-.8.8-.8s.8.4.8.8V65z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/HIDE.d05a8504.svg";
export { ForwardRef as ReactComponent };